import { Component, Input, OnInit } from '@angular/core';

import { Chart } from 'chart.js';

interface DataInterface {
    datasets: Array<DataSetDoughnutInterface|DataSetLineInterface|DataSetInterface>;
    width: number;
    height: number;
    labels: Array<String>;
    options?: ChartOptionsDoughnut|ChartOptionsLine;
}

interface DataSetInterface {
    label: string;
    data: number[];
}

interface ChartOptionsDoughnut {
    cutout: number|string;
    radius: number|string;
    rotation: number;
    circumference: number;
    animation: OptionAnimationDoughnut;
}

interface ChartOptionsLine {
    elements: ChartOptionsLineElements;
}

interface ChartOptionLineConfig {
    tension: number;
    backgroundColor: string;
    borderWidth: number;
    borderColor: string;
    borderCapStyle: string|'butt';
    borderDash: number[];
    borderDashOffset: number;
    borderJoinStyle: 'round'|'bevel'|'miter';
    capBezierPoints: boolean;
    cubicInterpolationMode: string|'default';
    fill: boolean|string;
    stepped: boolean;
}

interface ChartOptionPointConfig {
    radius: number;
    pointStyle: string|'circle';
    rotation: number;
    backgroundColor: string;
    borderWidth: number;
    borderColor: string;
    hitRadius: number;
    hoverRadius: number;
    hoverBorderWidth: number;
}

interface ChartOptionsLineElements {
    line: ChartOptionLineConfig;
    point: ChartOptionPointConfig;
}

interface OptionAnimationDoughnut {
    animateRotate: boolean;
    animateScale: boolean;
}

interface DataSetLineInterface extends DataInterface {
    backgroundColor: string;
    borderCapStyle: string;
    borderColor: string;
    borderDash: number;
    borderDashOffset: number;
    borderJoinStyle: 'round'|'bevel'|'miter';
    borderWidth: number;
    clip: number;
    cubicInterpolationMode: string;
    data:    object;
    drawActiveElementsOnTop: boolean;
    fill: boolean;
    hoverBackgroundColor: string;
    hoverBorderCapStyle: string;
    hoverBorderColor: string;
    hoverBorderDash: number;
    hoverBorderDashOffset: number;
    hoverBorderJoinStyle: 'round'|'bevel'|'miter';
    hoverBorderWidth: number;
    indexAxis: string;
    label: string;
    order: number;
    pointBackgroundColor: string;
    pointBorderColor: string;
    pointBorderWidth: number;
    pointHitRadius: number;
    pointHoverBackgroundColor: string;
    pointHoverBorderColor: string;
    pointHoverBorderWidth: number;
    pointHoverRadius: number;
    pointRadius: number;
    pointRotation: number;
    pointStyle: 'circle';
    segment:    object;
    showLine: boolean;
    spanGaps: boolean;
    stack: string|'line';
    stepped: boolean;
    tension: number;
    xAxisID: string;
    yAxisID: string;
}

interface DataSetDoughnutInterface extends DataInterface {
    backgroundColor?: string|string[];
    borderAlign?: 'center'|'inner';
    borderColor?: string;
    borderJoinStyle?: 'round'|'bevel'|'miter';
    borderRadius?: number|object;
    borderWidth?: number;
    circumference?: number;
    clip?: number|object|boolean;
    hoverBackgroundColor?: string;
    hoverBorderColor?: string;
    hoverBorderJoinStyle?: 'round'|'bevel'|'miter';
    hoverBorderWidth?: number;
    hoverOffset?: number;
    offset?: number|number[];
    rotation?: number;
    spacing?: number;
    weight?: number;
}

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit {

    private _chart: Chart;

    @Input('chartId') chartId = 'chartId';

    @Input('type') type: 'doughnut'|'pie'|'bar'|'bubble'|'line'|'polarArea'|'radar'|'scatter' = 'doughnut';

    @Input('data') data: DataInterface;

    ngOnInit() {
        this._initChart();
    }

    private _initChart(): void {
        setTimeout(() => {
            this._chart = new Chart(this.chartId, {
                type: this.type,
                data: this.data,
                options: this.data.options === undefined ? null : this.data.options
            });
        }, 1);
    }

    public update(data: DataSetInterface): void {
        this._chart.data = data;
        this._chart.update();
    }
}
